import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

export type Variant = 'A' | 'B' | 'none';

interface ExperimentContextValue {
  variant: Variant;
}

const ExperimentContext = createContext<ExperimentContextValue>({ variant: 'none' });

function assignVariant(): Variant {
  try {
    const key = 'abt_variant';
    const existing = window.localStorage.getItem(key) as Variant | null;
    if (existing === 'A' || existing === 'B') return existing;
    // Simple 50/50 split
    const v: Variant = Math.random() < 0.5 ? 'A' : 'B';
    window.localStorage.setItem(key, v);
    // Expose globally for analytics/debug
    (window as any).__abt_variant = v;
    return v;
  } catch {
    return 'none';
  }
}

export const ExperimentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [variant, setVariant] = useState<Variant>('none');
  useEffect(() => {
    setVariant(assignVariant());
  }, []);
  const value = useMemo(() => ({ variant }), [variant]);
  return (
    <ExperimentContext.Provider value={value}>
      {children}
    </ExperimentContext.Provider>
  );
};

export function useExperiment(): ExperimentContextValue {
  return useContext(ExperimentContext);
}
